import { jsx as n, jsxs as D } from "react/jsx-runtime";
import * as v from "react";
import k, { useContext as V } from "react";
import { u as m } from "./index-6a632112.mjs";
import { TableContext as $ } from "./table.js";
import { Q as o, B as w } from "./themes-5f0b3c3d.mjs";
import { Checkbox as p, CheckboxStateValues as d } from "./checkbox.js";
import { useWindowDimensions as E } from "./useWindowDimensions.js";
const B = m.th`
  ${(e) => `
  height: ${e.theme.components.dataTable.TableHeader.height};
  vertical-align: ${e.$marketingTable && e.theme.components.dataTable.TableHeader.verticalAlign || "middle"};
  padding: ${e.$showCheckboxEnabled ? e.theme.components.dataTable.TableHeader.paddingCheckbox : e.theme.components.dataTable.TableHeader.padding};
  align-items: ${e.theme.components.dataTable.TableHeader.alignItems};
  ${!e.$marketingTable && `&& > div > span {
    gap: ${e.theme.components.dataTable.TableHeader.div.gap};
    font-family: ${e.theme.components.dataTable.TableHeader.div.fontFamily};
    font-size: ${e.theme.components.dataTable.TableHeader.div.fontSize};
    font-style: ${e.theme.components.dataTable.TableHeader.div.fontStyle};
    font-weight: ${e.theme.components.dataTable.TableHeader.div.fontWeight};
    line-height: ${e.theme.components.dataTable.TableHeader.div.lineHeight};
  }`}
  
  text-align: ${e.theme.components.dataTable.TableHeader.textAlign};
  background-color: ${!e.$marketingTable && e.theme.components.dataTable.TableHeader.backgroundColor || "transparent"};
  @media ${o.tabletAndUp} {
    height: ${e.theme.components.dataTable.TableHeader.tabletView.height};
    padding: ${e.theme.components.dataTable.TableHeader.tabletView.padding};
    div:first-child {
      gap: ${e.theme.components.dataTable.TableHeader.tabletView.div[":first-child"].gap};
    }
   && > div:last-child {
      ${e.$marketingTable && `margin-bottom: ${e.theme.components.dataTable.TableHeader.tabletView.div[":last-child"].marginBottom}`}
    }
  `}
`, f = ({
  children: e,
  marketingTable: t,
  ...a
}) => {
  const { showCheckboxEnabled: l } = V($);
  return /* @__PURE__ */ n(
    B,
    {
      $showCheckboxEnabled: l,
      $marketingTable: t,
      ...a,
      children: e
    }
  );
}, x = ({
  children: e,
  style: t,
  contentAlignment: a,
  isMarketingTable: l,
  flexDirection: i = "unset"
}) => /* @__PURE__ */ n(
  A,
  {
    style: t,
    $contentAlignment: a,
    $isMarketingTable: l,
    $flexDirection: i,
    children: e
  }
), A = m.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableDataContentContainer.display};
      justify-content: ${e.$contentAlignment || "left"};
      align-items: ${e.$contentAlignment || "left"};
  flex-direction: ${e.$flexDirection};
    [data-component='checkbox-wrapper'] {
      label {
        padding-bottom: ${e.theme.components.dataTable.TableDataContentContainer['[data-component="checkbox-wrapper"]'].label.paddingBottom};
      }
    }
    `}
`, z = m.thead`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableHead.display};
    align-items: ${e.theme.components.dataTable.TableHead.alignItems};
    border-bottom: ${!e.$marketingTable && e.theme.components.dataTable.TableHead.borderBottom || "unset"};
    background-color: ${!e.$marketingTable && e.theme.components.dataTable.TableHead.backgroundColor || "#ffffff !important"};
    border-radius: ${e.theme.components.dataTable.TableHead.borderRadius};
    th:nth-child(2) {
      div:first-child {
        div:first-child {
          display: ${e.theme.components.dataTable.TableHead.th.div.firstChild.div.firstChild.display};
        }
      }
    }
    @media ${o.tabletAndUp} {
      display: ${e.theme.components.dataTable.TableHead.tabletView.display};
      flex-direction: ${e.theme.components.dataTable.TableHead.tabletView.flexDirection};
      th {
        position: ${!e.$marketingTable && e.theme.components.dataTable.TableHead.tabletView.th.position || "unset"};
        z-index: ${e.theme.components.dataTable.TableHead.tabletView.th.zIndex};
        top: ${e.theme.components.dataTable.TableHead.tabletView.th.top};
      }
      ${e.$isstickycolumn && e.$showcheckboxenabled ? `
          th:nth-child(2) {
            &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
          }
          th:first-child,
          th:nth-child(2)  {
            position: ${e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.position};
            left: ${e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.left};
            z-index: ${e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.zIndex};
          }
          th:nth-child(2){
            left: ${e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"]["nthChild: 2"].left};
          }
          ` : ""}
        ${e.$isstickycolumn ? `
          th:first-child {
            position: ${e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.position};
            left: ${e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.left};
            z-index: ${e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.zIndex};
            &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
          }
          ` : ""}
    }
    `}}
`, S = ({
  children: e,
  $checkboxProps: t,
  marketingTable: a
}) => {
  const {
    allCheckboxChecked: l,
    setAllCheckboxChecked: i,
    showOptionsEnabled: h,
    showCheckboxEnabled: c,
    isStickyColumnEnabled: s
  } = k.useContext($), { width: T } = E();
  return /* @__PURE__ */ D(
    z,
    {
      $showcheckboxenabled: c,
      $isstickycolumn: s,
      $marketingTable: a,
      children: [
        c && /* @__PURE__ */ n(
          f,
          {
            marketingTable: a,
            style: {
              padding: T >= w.tabletMin ? "3px 16px 4px" : "12px 16px 4px"
            },
            children: /* @__PURE__ */ n(x, { children: /* @__PURE__ */ n(
              p,
              {
                checkboxValue: l,
                isDisabled: t?.disabled,
                onChange: (C) => {
                  i && i(
                    l === d.UNCHECKED && d.CHECKED || d.UNCHECKED
                  ), t && t.onClick && t.onClick(
                    C,
                    l === d.UNCHECKED && d.CHECKED || d.UNCHECKED
                  );
                }
              }
            ) })
          }
        ),
        e,
        h && T >= w.tabletMin && /* @__PURE__ */ n(f, { marketingTable: a, children: /* @__PURE__ */ n(x, {}) })
      ]
    }
  );
}, U = m.tbody`

  @media ${o.tabletAndUp} {}
    ${(e) => {
  if (e.$isstickycolumn)
    return e.$showcheckboxenabled ? `
      td:nth-child(2){
       &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
      }
      td:first-child,
        td:nth-child(2)  {
          position: ${e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.position};
          left: ${e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.left};
           background-color: ${e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.backgroundColor};
        }
        td:nth-child(2){
          left: 52px;
        }
        && > tr:nth-child(2n) {
          td:first-child,
          td:nth-child(2)  {
            background-color: ${e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"]["&& > tr:nth-child(2n)"].td.firstChild.backgroundColor};
          }
        }
      ` : `
        td:first-child {
          position: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.position};
          left: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.left};
            background-color: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.backgroundColor};
     &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
  }
        && > tr:nth-child(2n) {
                td:first-child {
                   background-color: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.even.backgroundColor};
                }
        }
        `;
  if (e.$marketingTable)
    return `
          td:nth-child(n) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px #d1d5d9;
    }
    }
      td:nth-child(2n) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px #d1d5d9;
    }
    }
    td:last-child {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 2px;
      top:0;
      box-shadow: 1px 0px 1px 0px #d1d5d9;
    }
    }
    ${e.$isColumnButtonEnabled && `&& > tr:last-child {
          td:nth-child(2n-1) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px transparent;
    }
    }
      td:nth-child(2n):not(:last-child) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px transparent;
    }
    }
        td:last-child {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 2px;
      top:0;
      box-shadow: 1px 0px 1px 0px transparent;
    }
    }
    }`}
        `;
}}

    ${(e) => `
    width: ${e.theme.components.dataTable.TableBody.width};
    display: ${e.theme.components.dataTable.TableBody.display};
    flex-direction: ${e.theme.components.dataTable.TableBody.flexDirection};
    border-bottom-right-radius: ${e.theme.components.dataTable.TableBody.borderBottomRightRadius};
    border-bottom-left-radius: ${e.theme.components.dataTable.TableBody.borderBottomLeftRadius};
    && > div:nth-child(2n - 1) {
      background-color: ${e.theme.components.dataTable.TableBody["&& > div:nth-child(2n - 1)"].backgroundColor};
    }
    @media ${o.tabletAndUp} {
      display: ${e.theme.components.dataTable.TableBody.tabletView.display};

      && > tr:nth-child(even) {
        background-color: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.even.backgroundColor};

      }
       && > tr:nth-child(odd) {
        background-color: ${e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.odd.backgroundColor};

      }
      ${e.$isColumnButtonEnabled && `
      && > tr:last-child {
        background-color: ${e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].backgroundColor};
       td {
          padding-top: ${e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.paddingTop};
          padding-bottom: ${e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.paddingBottom};
          height: ${e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.height};
        }
      }
      `}
      
    }
    `}
  }
`, R = ({
  children: e,
  marketingTable: t,
  isColumnButtonEnabled: a,
  ...l
}) => {
  const { isStickyColumnEnabled: i, showCheckboxEnabled: h } = k.useContext($);
  return /* @__PURE__ */ n(
    U,
    {
      $isstickycolumn: i,
      $showcheckboxenabled: h,
      $marketingTable: t,
      $isColumnButtonEnabled: a,
      ...l,
      children: e
    }
  );
}, W = m.td`
  ${(e) => `
    @media ${o.tabletAndUp} {
      display: ${e.theme.components.dataTable.TableData[o.tabletAndUp].display};
      height: ${e.theme.components.dataTable.TableData[o.tabletAndUp].height};
      padding: ${e.theme.components.dataTable.TableData[o.tabletAndUp].padding};
      div:first-child {
        column-gap: ${e.theme.components.dataTable.TableData[o.tabletAndUp]["div:firstChild"].gap};
        align-items: ${e.theme.components.dataTable.TableData[o.tabletAndUp]["div:firstChild"].alignItems[e.$contentAlignment]};
      }
    }
    `}
`, u = ({
  children: e,
  contentAlignment: t,
  ...a
}) => /* @__PURE__ */ n(W, { ...a, $contentAlignment: t, children: e }), K = m.div`
  ${(e) => `
    color: ${e.theme.components.dataTable.TableDataDescription.color};
    font-family: ${e.theme.components.dataTable.TableDataDescription.fontFamily};
    font-size: ${e.theme.components.dataTable.TableDataDescription.fontSize};
    font-style: ${e.theme.components.dataTable.TableDataDescription.fontStyle};
    font-weight: ${e.theme.components.dataTable.TableDataDescription.fontWeight};
    line-height: ${e.theme.components.dataTable.TableDataDescription.lineHeight};
    `}
`, I = ({
  children: e
}) => /* @__PURE__ */ n(K, { children: e }), y = m.span`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableDataTextContainer.display};
    text-align: ${e.$contentAlignment};
    justify-content: ${e.$contentAlignment};
    align-items: ${e.theme.components.dataTable.TableDataTextContainer.alignItems};
       font-family: ${e.theme.components.dataTable.TableDataTextContainer.tabletView.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.tabletView.fontSize};
      font-style: ${e.theme.components.dataTable.TableDataTextContainer.tabletView.fontStyle};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.tabletView.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.tabletView.lineHeight};
    color: ${e.theme.components.dataTable.TableDataTextContainer.color};
    .label & {
      color: ${e.theme.components.dataTable.TableDataTextContainer.label.color};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.label.fontWeight};
    }

    ${e.$marketingTable && e.$marketingTableTitleSize === "small" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.lineHeight};
      color: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.color}
      ` || e.$marketingTable && e.$marketingTableTitleSize === "medium" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.lineHeight};]
      color: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.color}` || e.$marketingTable && e.$marketingTableTitleSize === "large" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.lineHeight};
      color: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.color}`}
    
    }
      
    }

    @media ${o.tabletAndUp} {
      ${e.$marketingTable && e.$marketingTableTitleSize === "small" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.lineHeight};` || e.$marketingTable && e.$marketingTableTitleSize === "medium" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.lineHeight};` || e.$marketingTable && e.$marketingTableTitleSize === "large" && `
        font-family: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontFamily};
      font-size: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontSize};
      font-weight: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontWeight};
      line-height: ${e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.lineHeight};`}
      
    }
    ${e.$showAllContent ? `
        overflow: ${e.theme.components.dataTable.TableDataTextContainer.showAllContent.overflow};
        text-overflow: ${e.theme.components.dataTable.TableDataTextContainer.showAllContent.textOverflow};
        display: ${e.theme.components.dataTable.TableDataTextContainer.showAllContent.display};
        -webkit-line-clamp: ${e.theme.components.dataTable.TableDataTextContainer.showAllContent.WebkitLineClamp};
        -webkit-box-orient: ${e.theme.components.dataTable.TableDataTextContainer.showAllContent.WebkitBoxOrient};
        ` : ""}
    `}
`, F = ({
  children: e,
  style: t,
  contentAlignment: a = "center",
  marketingTable: l = !1,
  marketingTableTitleSize: i
}) => {
  const { showAllTableDataContent: h, setShowAllTableDataContent: c } = V($), s = () => {
    c(!1);
  }, T = () => {
    c(!0);
  };
  return e.length > 40 ? /* @__PURE__ */ n(
    y,
    {
      style: t,
      $showAllContent: h,
      onMouseOver: s,
      onMouseOut: T,
      onBlur: T,
      $contentAlignment: a,
      $marketingTable: l,
      $marketingTableTitleSize: i,
      children: e
    }
  ) : /* @__PURE__ */ n(
    y,
    {
      $contentAlignment: a,
      $marketingTable: l,
      $marketingTableTitleSize: i,
      children: e
    }
  );
}, N = m.tr`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableRow.display};
    border-radius: ${e.theme.components.dataTable.TableRow.borderRadius};
    @media ${o.tabletAndUp} {
      display: ${e.theme.components.dataTable.TableRow.tabletView.display};
      td:not(:first-child) {
        div:first-child:only-child {
          color: ${e.theme.components.dataTable.TableRow.tabletView["td:not(:first-child)"]["div:first-child:only-child"].color};
        }
      }
    }
    width: ${e.theme.components.dataTable.TableRow.width};
    `}
`, M = ({
  children: e,
  $checkboxProps: t,
  id: a,
  $dropDownComponent: l,
  contentAlignment: i = "center",
  ...h
}) => {
  const {
    checkboxCheckedValues: c,
    setCheckboxChecked: s,
    showOptionsEnabled: T,
    showCheckboxEnabled: C
  } = k.useContext($), r = c?.find(
    (g) => g.id === a
  );
  return /* @__PURE__ */ D(N, { children: [
    C && /* @__PURE__ */ n(u, { contentAlignment: i, children: /* @__PURE__ */ n(b.CellContent, { style: { paddingBottom: "0px" }, children: /* @__PURE__ */ n(
      p,
      {
        checkboxValue: t?.checkboxDefaultValue ?? r?.value,
        isDisabled: t?.disabled || r?.disabled,
        onChange: (g) => {
          s && s(
            a,
            (r?.value === d.UNCHECKED || r?.value === void 0) && d.CHECKED || d.UNCHECKED
          ), t && t.onClick && t.onClick(
            g,
            a,
            (r?.value === d.UNCHECKED || r?.value === void 0) && d.CHECKED || d.UNCHECKED,
            !!t?.disabled
          );
        }
      }
    ) }) }),
    e,
    T && /* @__PURE__ */ n(u, { contentAlignment: i, children: /* @__PURE__ */ n(b.CellContent, { children: l }) })
  ] });
}, j = ({
  children: e,
  style: t,
  contentAlignment: a
}) => /* @__PURE__ */ n(
  O,
  {
    style: t,
    $contentAlignment: a,
    children: e
  }
), O = m.div`
  ${(e) => `
      display: flex;
      flex-direction: row;
      justify-content: ${e.$contentAlignment || "left"};
      align-items: center;
    `}
`, H = m.div`
  ${(e) => `
    border: ${e.theme.components.dataTable.TableV1.TableContainer.border};
    box-sizing: ${e.theme.components.dataTable.TableV1.TableContainer.boxSizing};
    border-radius: ${e.theme.components.dataTable.TableV1.TableContainer.borderRadius};
    width: ${e.theme.components.dataTable.TableV1.TableContainer.width};
    overflow-y: ${e.theme.components.dataTable.TableV1.TableContainer.overflowY};
    @media ${o.tabletAndUp} {
      overflow-x: ${e.theme.components.dataTable.TableV1.TableContainer.tabletView.overflowX};
      position: ${e.theme.components.dataTable.TableV1.TableContainer.tabletView.position};
      justify-content: ${e.theme.components.dataTable.TableV1.TableContainer.tabletView.justifyContent};
      align-items: ${e.theme.components.dataTable.TableV1.TableContainer.tabletView.alignItems};
    }
    `}
`, L = m.table`
  ${(e) => `    
background:${!e.$isMarketingTable && e.theme.components.dataTable.TableV1.TableComponent.background};
    height: ${e.$isEmpty && e.theme.components.dataTable.TableV1.TableComponent.height || "unset"};
    display: ${e.theme.components.dataTable.TableV1.TableComponent.display};
    flex-direction: ${e.theme.components.dataTable.TableV1.TableComponent.flexDirection};
    width: ${e.theme.components.dataTable.TableV1.TableComponent.width};
    thead {
      position: ${!e.$isMarketingTable && e.theme.components.dataTable.TableV1.TableComponent.thead.position || "unset"};
      z-index: ${e.theme.components.dataTable.TableV1.TableComponent.thead.zIndex};
      top: ${e.theme.components.dataTable.TableV1.TableComponent.thead.top};
    }
    @media ${o.mobile} {
      ${e.$showCheckboxEnabled ? `
      th:not(:nth-child(2)) {
        display: ${e.theme.components.dataTable.TableV1.TableComponent.mobileView.checkboxEnabled.th.display};
      }
      ` : `
      th:not(:nth-child(1)) {
        display: ${e.theme.components.dataTable.TableV1.TableComponent.mobileView.checkboxDisabled.th.display};
      }
      `}
    }
    @media ${o.tabletAndUp} {
      display: ${e.theme.components.dataTable.TableV1.TableComponent.tabletView.display};
      flex-direction: ${e.theme.components.dataTable.TableV1.TableComponent.tabletView.flexDirection};
      border-collapse: ${e.theme.components.dataTable.TableV1.TableComponent.tabletView.borderCollapse};
      ${e.$showCheckboxEnabled ? `
      th:not(:nth-child(2)) {
        display: ${e.theme.components.dataTable.TableV1.TableComponent.tabletView.checkboxEnabled.th.display};
      }
      ` : `
      th:not(:nth-child(1)) {
        display: ${e.theme.components.dataTable.TableV1.TableComponent.tabletView.checkboxDisabled.th.display};
      }
      `}
    }
    `}
`, b = ({
  children: e,
  style: t,
  isMarketingTable: a = !1,
  isEmpty: l,
  ...i
}) => {
  const { showCheckboxEnabled: h } = v.useContext($);
  return /* @__PURE__ */ n(H, { style: t, ...i, children: /* @__PURE__ */ n(
    L,
    {
      $isEmpty: l,
      $showCheckboxEnabled: h,
      $isMarketingTable: a,
      children: e
    }
  ) });
};
b.Head = S;
b.Header = f;
b.Body = R;
b.Row = M;
b.Cell = u;
b.CellWrapper = j;
b.CellContent = x;
b.CellContentText = F;
b.CellDescription = I;
b.Container = H;
const Z = m.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableContainer.display};
    flex-direction: ${e.theme.components.dataTable.TableContainer.flexDirection};
    gap: ${e.theme.components.dataTable.TableContainer.gap};
    `}
`;
export {
  Z as T,
  b as a,
  S as b
};
